import { withStyles } from '@material-ui/core';
import { HeaderDetails } from './index';

const styles = (theme) => ({
  headerContainer: {
    position: 'relative',
    display: 'block',
    width: '100%'
  },
  groupContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginTop: 10,
  },
  headerElement: {
    flex: '0 0 auto',
    boxSizing: 'border-box',
    '&:not(:last-child)': {
      marginRight: '6px'
    }
  },
  logoContainer: {
    position: 'absolute',
    top: '0',
    right: '0',
    padding: '5px',
    height: '20px',
    zIndex: 500
  },
  loadingGuide: {
    color: theme.printTableLabel,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '1px',
    textDecorationLine: 'underline',
    textTransform: 'uppercase',
    textAlign: 'center'
  }
});

const Header = ({ classes, headerData }) => {
  return (
    <div className={classes.headerContainer}>
      <img
        src="../../../../../../images/RouteMax_Logo_Print.svg"
        className={classes.logoContainer}
        alt="RouteMax Logo"
      />
      <div className={classes.loadingGuide}>Loading Guide</div>
      <div className={classes.groupContainer} style={headerData.styles || {}}>
        {headerData.fields.map((header, index) => (
          <div key={index} className={classes.headerElement} style={header.styles || {}}>
            <HeaderDetails label={header.label} value={header.value} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default withStyles(styles)(Header);
